import { conciliationFlowGuide } from "./conciliationFlow/guide";
import navigation from "app/navigation/catalog";
import { guideDetails, reconciliationDetails } from "./guideDetails";

const guide = (purpose, steps, reading, notes) => ({ purpose, steps, reading, notes });
const cycles = (system) =>
  guide(
    `Solicita aperturas y cierres en ${system} y revisa el resultado de cada intento.`,
    [
      "Selecciona el comercio; espera la carga de sus terminales y elige la terminal del movimiento.",
      "Escribe la placa y la fecha y hora de la operación en horario de Colombia. Revisa si la terminal corresponde a entrada o salida.",
      "Revisa los datos de la operación antes de confirmar y espera la respuesta.",
      "Consulta el historial de Aperturas o Cierres y abre el detalle del intento para revisar su mensaje y código de resultado.",
    ],
    [
      "Aperturas y cierres tienen historiales separados. La fecha de operación corresponde al ingreso o salida; la fecha de registro corresponde al intento.",
      "El historial incluye solicitudes rechazadas. Que exista un registro no significa que se haya realizado la operación.",
    ],
    [
      "La identidad del operador proviene de la sesión. Si no se identifica, vuelve a iniciar sesión.",
      "Verifica horarios, terminal y estado del ciclo antes de repetir una solicitud.",
    ]
  );
export const specificGuides = {
  agendamiento: guide(
    "Programa actividades de mantenimiento por comercio, zona y equipo.",
    [
      "Abre Crear Agendamiento.",
      "Completa fecha y hora, técnico, comercio, duración, zona, equipo, tipo de actividad y descripción.",
      "Revisa los campos obligatorios y guarda. Consulta la programación en la tabla.",
      "Usa las acciones del registro para editar o eliminar la actividad cuando corresponda.",
    ],
    [
      "La zona y el equipo identifican dónde se realizará la actividad. Los catálogos se administran en Configuración de Mantenimiento.",
      "La lista permite consultar la programación registrada; verifica la fecha y el técnico de cada actividad.",
    ],
    ["Verifica técnico y fecha antes de guardar; eliminar una actividad modifica la programación."]
  ),
  ordenes: guide(
    "Esta pantalla se identifica como Órdenes de Trabajo, pero actualmente muestra usuarios. Revisa qué información aparece antes de realizar una acción.",
    [
      "Revisa las columnas de la tabla: ID, usuario, correo, rol y estado.",
      "Comprueba con el administrador si esta es la pantalla indicada para la tarea que necesitas realizar.",
      "No utilices eliminar para cancelar una actividad: la acción está vinculada a una cuenta de usuario.",
    ],
    [
      "El nombre de la pantalla y la información de la tabla no coinciden actualmente. Las acciones de modificación están conectadas a usuarios.",
    ],
    [
      "Para gestionar una orden de mantenimiento, solicita al administrador que confirme el procedimiento. No supongas que Resolver agendamiento solo afecta a una actividad.",
    ]
  ),
  configuracion: guide(
    "Administra los catálogos de Mantenimiento.",
    [
      "Selecciona Comercios, Zonas, Equipos o Actividades.",
      "Consulta los registros existentes antes de crear uno nuevo.",
      "Abre Crear o Editar, completa el formulario y guarda.",
      "Comprueba el resultado en el catálogo correspondiente.",
    ],
    ["Estos catálogos proporcionan las opciones de los formularios de agendamiento."],
    ["Antes de eliminar un registro, verifica si se utiliza en la programación."]
  ),
  cierre: guide(
    "Registra el cierre de un turno de caja y consulta los cierres disponibles para tu rol.",
    [
      "Selecciona el usuario y el turno que vas a cerrar.",
      "Comprueba caja, número de turno, fechas y datos del formulario.",
      "Completa los campos requeridos y revisa la confirmación antes de cerrar.",
      "Si tu rol habilita el historial, consulta el detalle y descarga el comprobante PDF.",
    ],
    [
      "El cierre se realiza sobre el turno seleccionado. El historial tiene restricciones adicionales por rol.",
    ],
    ["No confirmes un turno distinto al que estás revisando. Respeta los bloqueos del formulario."]
  ),
  vipCame: guide(
    "Consulta vehículos VIP y ocupación de cupos por grupo.",
    [
      "Busca y selecciona un grupo VIP.",
      "Revisa sus cupos asignados, usados y disponibles.",
      "Cambia el modo de vista para consultar vehículos o el resumen de grupos.",
      "Busca por placa o grupo y usa los filtros Todos, En VIP, En General, Fuera y Sin información. Al vaciar la búsqueda se recuperan los vehículos del filtro seleccionado. Actualizar vuelve a consultar el grupo actual.",
    ],
    [
      "Los vehículos registrados pueden estar dentro o fuera del parqueadero. Los que están dentro ocupan cupos.",
      "La cantidad de vehículos registrados no equivale a los cupos asignados.",
    ],
    [
      "Si falla la consulta de ocupación, los vehículos registrados se conservan como Sin información y no se calculan cupos ocupados ni disponibles. No significa que estén fuera. Pulsa Actualizar para reintentar.",
    ]
  ),
  informeDiario: guide(
    "Consulta el informe diario de movimientos de Came.",
    [
      "Selecciona el período y los filtros disponibles en el informe.",
      "Ejecuta la consulta y revisa entradas, salidas y el detalle mostrado.",
      "Contrasta los registros con el período seleccionado antes de utilizar el resultado.",
    ],
    [
      "Un movimiento y un vehículo no representan necesariamente la misma cantidad. El informe corresponde a los filtros aplicados.",
    ],
    ["Si cambias el período, vuelve a consultar los datos correspondientes."]
  ),
  bicicletas: guide(
    "Gestiona usuarios, bicicletas, ingresos, salidas y ocupación de ganchos.",
    [
      "Abre Registrar Ingreso y busca o registra al usuario.",
      "Selecciona una bicicleta de ese usuario o crea una con su código/serie y color.",
      "Selecciona un gancho disponible. Revisa usuario, bicicleta y gancho antes de confirmar.",
      "Consulta los ganchos ocupados para ver el detalle y registra la salida desde las acciones del movimiento.",
    ],
    [
      "El fondo del gancho indica disponibilidad; la muestra de color identifica la bicicleta.",
      "El ingreso debe quedar asociado al usuario y a la bicicleta seleccionados. Un usuario puede tener varias bicicletas.",
      "En Usuarios puedes consultar y gestionar las bicicletas asociadas.",
    ],
    [
      "No elijas una bicicleta de otro usuario. Comprueba la serie, además del color, cuando haya bicicletas similares.",
    ]
  ),
  frecuencia: guide(
    "Consulta la frecuencia de visitas de vehículos por período.",
    [
      "Selecciona fecha inicio y fecha fin.",
      "Aplica los tipos de tarjeta y demás filtros disponibles.",
      "Ejecuta la consulta y revisa las visitas del período.",
      "Usa Restablecer para volver a los filtros iniciales.",
    ],
    ["La frecuencia resume visitas según el período y tipos de tarjeta consultados."],
    ["Compara períodos y filtros equivalentes para interpretar variaciones."]
  ),
  permanencia: guide(
    "Consulta la duración de las visitas al estacionamiento.",
    [
      "Selecciona las fechas y los filtros de consulta.",
      "Consulta el informe de permanencia.",
      "Revisa entrada, salida y duración de cada visita mostrada.",
    ],
    ["La permanencia corresponde a la duración de una visita; no equivale al número de visitas."],
    ["Comprueba si el movimiento tiene salida antes de interpretarlo como una visita finalizada."]
  ),
  usoVip: guide(
    "Consulta el historial de entradas y salidas del parqueadero VIP.",
    [
      "Selecciona el período y los filtros disponibles.",
      "Consulta el historial y localiza el vehículo o movimiento.",
      "Revisa ingreso general, ingreso VIP, salida VIP y salida general de cada ciclo. El segundo GPIN posterior al ingreso general identifica VIP.",
      "Consulta la gráfica de ingresos por placa y el promedio de permanencia VIP. La tabla y las descargas incluyen únicamente ciclos con ingreso VIP identificado.",
    ],
    [
      "El informe muestra movimientos de uso VIP. Los cupos por grupo se consultan en VIP Came, si tienes ese acceso.",
    ],
    ["Verifica el período antes de comparar movimientos."]
  ),
  edificio: guide(
    "Gestiona registros de parqueadero en las propiedades autorizadas.",
    [
      "Selecciona la propiedad o comercio disponible para tu usuario.",
      "Filtra registros por búsqueda y fechas.",
      "Para un ingreso, abre Nuevo Ciclo y completa sus datos.",
      "Para una salida, usa Cerrar ciclo sobre el registro activo. Actualiza y verifica el resultado.",
    ],
    [
      "Un ciclo activo está pendiente de salida; uno completado corresponde a un movimiento finalizado.",
      "Las propiedades y acciones disponibles dependen de los permisos asignados.",
    ],
    ["Comprueba propiedad, placa y terminal antes de crear o cerrar un ciclo."]
  ),
  administracion: guide(
    "Administra usuarios de parqueadero de las propiedades autorizadas.",
    [
      "Selecciona la propiedad en el encabezado.",
      "Consulta usuarios e indicadores de activos y expirados.",
      "Abre Nuevo Usuario o Editar y completa los datos requeridos.",
      "Guarda y verifica el registro dentro de la propiedad.",
    ],
    ["La propiedad seleccionada determina el contexto de los usuarios mostrados."],
    [
      "Confirma propiedad y vigencia antes de guardar. Las opciones dependen de los permisos de Copropiedades.",
    ]
  ),
  propiedades: guide(
    "Administra las propiedades registradas en Goper.",
    [
      "Consulta el listado y los indicadores de propiedades.",
      "Abre Nueva Propiedad o edita una existente.",
      "Completa los datos solicitados, revisa el estado y guarda.",
      "Comprueba el resultado en la tabla.",
    ],
    ["Las propiedades organizan los usuarios y registros de parqueadero."],
    ["Verifica nombre e identificador para evitar duplicar propiedades."]
  ),
  permisos: guide(
    "Asigna propiedades y acciones de Copropiedades a los usuarios habilitados.",
    [
      "Localiza al usuario en el listado.",
      "Abre sus permisos y revisa las asignaciones actuales.",
      "Selecciona propiedades y acciones; retira las que ya no correspondan.",
      "Guarda y vuelve a consultar los permisos.",
    ],
    [
      "Estos permisos controlan el alcance dentro de Copropiedades. Los permisos de módulos se administran en Roles.",
    ],
    [
      "Comprueba al usuario antes de cambiar accesos. El listado incluye los roles habilitados por esta pantalla.",
    ]
  ),
  carga: guide(
    "Importa y consulta tags del sistema.",
    [
      "Prepara el Excel siguiendo la guía de importación: Reverse Number, Number Below the QR, Code QR, ESTADO, LOTE y ESTADO TAGS.",
      "Selecciona el archivo y revisa la validación de columnas, datos y duplicados.",
      "Confirma la importación y espera su resultado.",
      "Abre la lista de tags y filtra por lote para revisar la carga.",
    ],
    [
      "Los errores indican las filas que debes corregir. Los identificadores únicos no deben repetirse.",
    ],
    ["Todas las columnas requeridas deben tener datos. El archivo no debe superar 40 MB."]
  ),
  cargalazo: guide(
    "Importa y administra los registros de Lazo.",
    [
      "Descarga la plantilla de ejemplo del formulario.",
      "Completa PLATE, COMMERCE, COMMERCE_IP, NAME, LAST_NAME y PHONE.",
      "Selecciona el Excel .xlsx o .xls y revisa la validación.",
      "Confirma la carga y revisa los registros en la tabla.",
    ],
    [
      "La plantilla define las columnas esperadas. Conserva sus nombres para evitar errores de validación.",
    ],
    ["Corrige las filas indicadas por el resultado antes de repetir una importación."]
  ),
  facturas: guide(
    "Importa y administra facturas del sistema financiero.",
    [
      "Prepara un .xlsx con # Factura, NIT, Empresa, Valor y Código.",
      "Selecciona el archivo y revisa columnas y valores.",
      "Confirma la importación y consulta las facturas cargadas.",
      "Usa la edición de la tabla cuando necesites corregir campos, incluido el código empresarial.",
    ],
    ["Las facturas importadas se crean como pendientes. El código empresarial es obligatorio."],
    ["El archivo no debe superar 10 MB. Usa valores numéricos y evita filas vacías en los datos."]
  ),
  recaudo: guide(
    "Consulta pagos y comprobantes del portal de recaudo.",
    [
      "Aplica los filtros y localiza factura, empresa o transacción.",
      "Revisa monto, fecha y estado del pago.",
      "Abre el comprobante para consultar el detalle.",
      "Descarga su PDF cuando necesites el soporte.",
    ],
    [
      "CONCILIATED se presenta como Conciliado. Ese estado es distinto de un pago aprobado.",
      "Los totales dependen de los registros y filtros consultados.",
    ],
    ["Comprueba el estado real y el ID de transacción antes de utilizar el comprobante."]
  ),
  comercios: guide(
    "Consulta el tablero de comercios y sus indicadores de operación.",
    [
      "Aplica los filtros disponibles para elegir comercio o conjunto de datos.",
      "Revisa indicadores y secciones del tablero.",
      "Abre el detalle de la información que necesites contrastar.",
    ],
    [
      "Este tablero presenta seguimiento. La configuración de integraciones está en Comercios de Jarvis, si tienes ese acceso.",
    ],
    ["Interpreta los resultados dentro del período y filtros seleccionados."]
  ),
  tablerogerencial: guide(
    "Analiza aceptación y recaudo en el tablero gerencial.",
    [
      "Selecciona la vista de aceptación o recaudo y sus filtros.",
      "Revisa métricas, totales y gráficas de efectividad.",
      "Consulta distribuciones por fecha, pasarela, servicio o franquicia, según la vista.",
      "Utiliza el detalle para contrastar el resumen.",
    ],
    [
      "Las gráficas muestran porcentajes de efectividad sobre la base de cada grupo; no montos de dinero.",
      "La vista elegida determina las dimensiones de comparación.",
    ],
    ["Compara resultados con el mismo período y base de filtros."]
  ),
  infoConcesion: guide(
    "Consulta las conciliaciones de un comercio y, si perteneces al rol Concesiones, envía el reporte de tu concesión.",
    [
      "Si tu rol es Concesiones, verifica el nombre y el código asignados. Si tienes otro rol con acceso, selecciona el comercio que deseas consultar; tu acceso será solo de lectura.",
      "Busca una llave en la tabla. Cada fila corresponde a una conciliación del comercio consultado.",
      "Pulsa Detalle para revisar los pasos conciliados y las novedades. La cantidad de la tabla es información de consulta, no un dato que se copie a tu reporte.",
      "Solo el rol Concesiones dispone de Registrar. Al abrirlo, la llave y el código ya están definidos; la cantidad de pasos y el valor total están vacíos para que ingreses tu propia información.",
      "Adjunta obligatoriamente un soporte Excel .xlsx o .xls con contenido, de hasta 10 MB. Puedes cambiar el archivo o quitarlo antes de cerrar.",
      "Escribe una observación, revisa tus cifras y pulsa Enviar respuesta. El formulario completo y el Excel son obligatorios. Completa pasos y valor de cada peaje cargado para tu concesión; todos deben tener información, incluso cero cuando corresponda. Los totales se calculan automáticamente y se envía el desglose por peaje. Sin soporte no se envía la respuesta. Cuando el envío se confirme, Registrar desaparecerá de esa llave, el formulario se cerrará y se abrirá automáticamente la respuesta para que puedas revisarla. Si falla, el formulario conservará tus datos.",
      "Cuando una llave tenga una respuesta guardada, pulsa Ver respuesta para consultar los pasos, valor y observación reportados por la concesión, el soporte si existe, quién la envió y su fecha en hora de Colombia. También puedes consultarla después de recargar la página.",
      "Si la respuesta tiene un soporte adjunto, pulsa Ver Excel para revisar las celdas de la primera hoja sin salir del sistema. El visualizador es el mismo de Lotes: muestra los archivos disponibles y permite descargar el Excel original. Ciérralo para volver a la respuesta sin modificar ni reenviar el archivo.",
    ],
    [
      "Las seis columnas muestran llave, código, nombre del comercio, cantidad de pasos conciliados, estado y acciones. Todas están centradas y tienen el mismo ancho.",
      "En el formulario no se muestra la cantidad de pasos conciliados de Gopass ni se completa automáticamente. La concesión debe escribir sus pasos y su valor total en pesos colombianos.",
    ],
    [
      "Enviar respuesta remite la llave, el código de tu concesión, tus pasos, el valor total, la observación y el Excel obligatorio. La confirmación de envío no significa que la conciliación esté aprobada; el estado de la tabla sigue como No informado hasta disponer de ese dato.",
      "Si ocurre un error, los campos y el archivo se conservan para revisarlos. Si no se pudo confirmar el envío por falta de conexión, verifica si fue recibido antes de repetirlo.",
      "El Excel no puede estar vacío. Al cerrar el formulario o cambiar de llave, comercio o cuenta se descarta el archivo seleccionado; deberás adjuntarlo de nuevo.",
      "Si alguna cantidad no está disponible, pulsa Actualizar. El detalle puede consultarse aunque no se haya podido completar el resumen de la tabla.",
    ]
  ),
  gestionConciliaciones: guide(
    "Consulta conciliaciones por concesión, peaje y período.",
    [
      "Selecciona concesión y, si corresponde, peaje.",
      "Define fecha inicio y fin y pulsa Buscar.",
      "Revisa detalle, Total pasos, totales y diferencias.",
      "Exporta el resultado a Excel cuando necesites analizarlo fuera de la aplicación. El archivo conserva el mismo orden de columnas y los bloques verde, amarillo y azul.",
    ],
    ["Los totales corresponden a la consulta aplicada. El detalle permite revisar diferencias."],
    [
      "El comentario de cada fila se guarda en el servidor para su concesión, fecha y peaje. Una fila con observación no permite agregar otra. El Excel incluye Total pasos y Observación; los resúmenes suman los pasos sin contar nuevamente los subtotales.",
    ]
  ),
  configuracionPeajes: guide(
    "Consulta y ajusta parámetros de liquidación y consolidación por concesión.",
    [
      "Busca la concesión por nombre, código o peaje.",
      "Abre su configuración y revisa los parámetros actuales.",
      "Ajusta los valores y cortes horarios permitidos por el formulario.",
      "Guarda y actualiza la matriz para verificar el resultado.",
    ],
    ["La matriz agrupa la configuración de los peajes por concesión."],
    [
      "Los nombres de peajes no son editables. Los parámetros intervienen en la liquidación; revísalos antes de guardar.",
    ]
  ),
  lotes: guide(
    "Importa y consulta lotes de conciliación financiera.",
    [
      "Busca por ID, nombre o llave de conciliación.",
      "Filtra por llave y fechas de creación.",
      "Para una carga, usa la importación disponible y revisa las validaciones del archivo.",
      "Comprueba el lote y el resultado en el listado.",
    ],
    ["La llave de conciliación y fecha de creación permiten ubicar el lote de trabajo."],
    ["Verifica si el lote ya existe antes de repetir una importación."]
  ),
  lotesFinanciera: guide(
    "Consulta y administra lotes financieros.",
    [
      "Busca por ID, nombre o llave de conciliación.",
      "Aplica llave y rango de fechas de creación.",
      "Revisa el lote y las acciones disponibles para sus registros.",
      "Limpia los filtros para volver al conjunto disponible.",
    ],
    ["Los filtros activos aparecen en la cabecera y su combinación determina el resultado."],
    ["Confirma la llave y el lote antes de ejecutar acciones sobre los registros."]
  ),
  reportes: guide(
    "Gestiona destinatarios y consulta correos de pasos rechazados.",
    [
      "Busca comercio, ID o reporte.",
      "Abre Ver y gestionar correos para revisar o actualizar destinatarios.",
      "Abre el registro de correos para consultar envíos y estados del proveedor.",
      "Actualiza el listado para revisar la información disponible.",
    ],
    [
      "La cantidad de correos enviados corresponde al registro de envíos; los destinatarios configurados son un dato distinto.",
      "Un envío registrado no garantiza la lectura del correo por el destinatario.",
    ],
    ["Verifica las direcciones antes de guardar cambios de destinatarios."]
  ),
  financiera1: guide(
    "Consulta el informe financiero integrado de parqueaderos.",
    [
      "Abre el módulo y espera la carga del informe.",
      "Usa sus filtros y controles para seleccionar período o conjunto de datos.",
      "Consulta las visualizaciones y el detalle disponible.",
    ],
    ["El contenido y las opciones pertenecen al informe Power BI integrado."],
    ["La disponibilidad también depende del servicio integrado y de su autorización."]
  ),
  indicadores: guide(
    "Analiza tickets GLPI, estados, grupos técnicos y tiempos de solución.",
    [
      "Selecciona fecha inicio, fecha fin y grupos técnicos; pulsa Aplicar.",
      "Revisa tarjetas y gráficas de evolución y distribución.",
      "Abre Detalle de tickets para buscar, ordenar y consultar los registros.",
      "En Exportar reporte elige Excel de resumen o PDF de gráficas e indicadores.",
    ],
    [
      "Las fechas filtran apertura, en horario de Colombia. Los estados son los actuales de la consulta.",
      "Pendientes >3 días se evalúa al consultar. La referencia de solución es 24 horas corridas y solo considera resueltos/cerrados con tiempo válido.",
      "Los reportes usan las fechas y grupos aplicados; la búsqueda y paginación del detalle no reducen su base. Las líneas no muestran etiquetas numéricas; las barras sí.",
    ],
    [
      "Un dato sin base no equivale a cero. Reintenta una carga fallida antes de interpretar resultados.",
    ]
  ),
  alertas: guide(
    "Supervisa alertas de equipos y revisa el problema reportado.",
    [
      "Busca por mensaje, comercio, equipo, IP o ID y filtra por tipo.",
      "Localiza la alerta y abre su detalle.",
      "Revisa problema, equipo, prioridad y fechas del evento.",
      "Observa las actualizaciones del listado para comprobar si el sistema sigue reportando la alerta.",
    ],
    [
      "Las críticas se destacan en rojo y parpadean. El sistema retira las alertas que deja de encontrar en la actualización.",
      "El detalle permite desplegar los datos originales para diagnóstico.",
    ],
    [
      "Las alertas no se silencian desde esta pantalla. Su retirada depende de lo reportado por el sistema.",
    ]
  ),
  parking: guide(
    "Audita comercios, terminales y ciclos de parqueadero.",
    [
      "Busca el comercio o terminal que necesitas revisar.",
      "Revisa estadísticas y registros de la tabla.",
      "Abre el detalle disponible para contrastar comercio, terminal o ciclo.",
      "Limpia los filtros para volver al conjunto consultado.",
    ],
    ["Esta vista permite revisar información de auditoría reportada por los sistemas de parking."],
    ["Verifica comercio y terminal antes de sacar conclusiones sobre una operación."]
  ),
  redes: guide(
    "Consulta la disponibilidad reportada de switches y equipos de red.",
    [
      "Localiza el comercio o equipo con la búsqueda y filtros disponibles.",
      "Revisa los indicadores y el detalle de la red.",
      "Identifica equipos Sin alcance y contrasta nombre e IP.",
      "Actualiza la consulta para verificar el estado reportado.",
    ],
    [
      "Sin alcance significa que la consulta no reporta comunicación; no identifica por sí sola la causa.",
      "Los datos ausentes no equivalen a un equipo marcado sin alcance.",
    ],
    ["Comprueba la última consulta antes de escalar una novedad."]
  ),
  readers: guide(
    "Supervisa readers y utiliza las acciones de diagnóstico habilitadas.",
    [
      "Localiza comercio y reader mediante los filtros.",
      "Revisa el estado reportado y los datos del equipo.",
      "Para Enviar pulso, revisa destino y duración antes de confirmar.",
      "Para reiniciar, confirma el reader correcto y espera la respuesta. Consulta el período de espera antes de reiniciarlo de nuevo.",
    ],
    [
      "Después de reiniciar, la aplicación te hace esperar 5 minutos antes de volver a reiniciar ese lector.",
      "Que el comando se confirme no implica que el equipo ya esté disponible; verifica una consulta posterior.",
    ],
    ["El pulso y el reinicio actúan sobre equipos reales. Confirma comercio, reader y duración."]
  ),
  camaras: guide(
    "Consulta cámaras por comercio y disponibilidad reportada.",
    [
      "Selecciona un comercio o deja todos.",
      "Busca por cámara, comercio o IP y elige Con alcance, Sin alcance o Sin verificar.",
      "Pulsa Consultar y revisa el listado y los datos del equipo.",
      "Usa Actualizar o Limpiar para una nueva consulta.",
    ],
    ["Con alcance, Sin alcance y Sin verificar son categorías distintas."],
    ["La disponibilidad del equipo no certifica la calidad ni continuidad del video."]
  ),
  creacionCiclo: guide(
    "Registra ingresos y revisa los intentos de creación de ciclos.",
    [
      "Selecciona comercio, placa y fecha y hora de ingreso en horario de Colombia.",
      "Pulsa Revisar y crear y verifica la confirmación.",
      "Confirma y espera la respuesta.",
      "Abre el detalle del historial para revisar ingreso, fecha del intento, controlador y resultado.",
    ],
    [
      "El historial incluye intentos exitosos y rechazados. La fecha de ingreso y la del intento representan momentos distintos.",
    ],
    ["Revisa el mensaje antes de repetir una creación; el vehículo puede tener un ciclo existente."]
  ),
  ciclosAccespark: cycles("Accespark"),
  ezytecCiclo: cycles("Ezytec"),
  cerberus: guide(
    "Consulta fuentes de logs de Cerberus y su visor en tiempo real.",
    [
      "Busca por nombre, host, URL o ID.",
      "Aplica los filtros de estado y host/IP.",
      "Abre el visor de la fuente elegida y revisa las líneas recibidas.",
      "Cierra el visor al terminar; Actualizar recarga las fuentes.",
    ],
    [
      "El estado de una fuente y la llegada de mensajes nuevos son datos distintos. Un visor sin líneas no prueba que el servicio esté caído.",
    ],
    [
      "Si no conecta, revisa el error y reintenta con la fuente correcta. Los logs pueden contener información operativa.",
    ]
  ),
  placas: guide(
    "Consulta el diagnóstico de placas por comercio en Cerberus y Poseidon.",
    [
      "Selecciona el comercio.",
      "Escribe la placa y pulsa Consultar placa por comercio.",
      "Revisa por separado las respuestas de Cerberus y Poseidon.",
      "Limpia la consulta o cambia los datos para otro vehículo.",
    ],
    [
      "Cambiar placa o comercio descarta el resultado anterior.",
      "Cada sistema puede reportar un resultado distinto; revisa su mensaje y datos.",
    ],
    ["Un fallo de consulta no significa que el vehículo no tenga ciclo."]
  ),
  comerciosJarvis: guide(
    "Configura comercios, integración y apertura CB en Jarvis.",
    [
      "Busca por comercio, ID o integración y filtra por estado y tipo.",
      "Abre Agregar comercio y selecciona el catálogo, o usa Editar.",
      "Configura tipo, integración, estado y apertura CB.",
      "Abre Revisar configuración y confirma los valores antes de guardar.",
    ],
    [
      "El nombre e identificador del comercio no se editan libremente.",
      "Los contadores corresponden al listado filtrado. La última carga correcta indica cuándo se actualizó el catálogo.",
    ],
    ["Si el guardado queda sin confirmación, actualiza el listado antes de repetirlo."]
  ),
  whatsappJarvis: guide(
    "Configura reglas y destinos WhatsApp por comercio y terminal.",
    [
      "Combina búsqueda, grupo NOC, estado y pulso.",
      "Abre Agregar configuración o Editar.",
      "Selecciona comercio, grupo NOC, workflow y terminal. En creación elige el grupo WhatsApp disponible; su Chat ID se completa con el grupo.",
      "Revisa estado y pulso, abre Revisar configuración y confirma los datos.",
    ],
    [
      "Los workflows de integración permiten terminal opcional. Cambiar el comercio limpia la terminal anterior.",
      "Nombre e ID provienen del catálogo. En edición, grupo WhatsApp y Chat ID se muestran como consulta.",
      "Los contadores corresponden a los filtros aplicados.",
    ],
    [
      "Guardar configura Jarvis; no es un envío manual de mensajes. Verifica comercio, terminal y grupo.",
    ]
  ),
  copropiedadesW: guide(
    "Administra alertas de WhatsApp para Copropiedades.",
    [
      "Combina búsqueda, estado, pulso y grupo NOC.",
      "Abre Nueva Configuración o edita una existente.",
      "Revisa comercio, terminal, workflow, grupo NOC y destino WhatsApp.",
      "Completa los campos obligatorios, confirma y consulta el resultado del guardado.",
    ],
    [
      "Los filtros activos se muestran como etiquetas removibles. Los indicadores incluyen activos, pulso, terminal y grupos NOC.",
    ],
    ["Comprueba destino WhatsApp y comercio antes de guardar."]
  ),
  rol: guide(
    "Crea roles y define los módulos habilitados para cada rol.",
    [
      "Busca el rol por nombre o ID.",
      "Abre Crear rol o Editar permisos.",
      "Selecciona los módulos que debe tener habilitados.",
      "Guarda y comprueba los permisos del rol.",
    ],
    [
      "Los permisos determinan navegación y acceso a módulos. Los roles se asignan a las cuentas desde Usuarios.",
    ],
    ["Cambiar un rol afecta a sus usuarios. Otorga solo los accesos que correspondan."]
  ),
  usuario: guide(
    "Crea y administra cuentas de acceso a Goper.",
    [
      "Busca por nombre, correo, rol o ID; filtra por rol y estado.",
      "Abre Crear usuario o Editar usuario.",
      "Completa los campos y asigna el rol y estado correctos.",
      "Guarda y comprueba el registro.",
    ],
    ["El rol controla los módulos habilitados. El estado diferencia usuarios activos e inactivos."],
    [
      "Verifica la cuenta antes de eliminarla o cambiar su rol. No compartas contraseñas en observaciones.",
    ]
  ),
};
specificGuides.reportesConciliaciones = {
  ...specificGuides.reportes,
  purpose: "Gestiona destinatarios y consulta correos de conciliaciones.",
};
function reconciliationGuide(item, parents) {
  return guide(
    `Consulta las conciliaciones de ${item.name} en ${
      parents.includes("Peajes") ? "Peajes" : "Parqueaderos"
    }.`,
    [
      "Abre la concesión o parqueadero correspondiente.",
      "Selecciona la conciliación y los filtros disponibles.",
      "Revisa resumen y detalle de transacciones de la consulta.",
      "Contrasta registros y diferencias antes de utilizar los resultados para seguimiento financiero.",
    ],
    [
      "Los valores corresponden al conjunto consultado. Revisa estados de conciliación y detalles disponibles en esta vista.",
      "Las opciones pueden variar según la integración de la concesión o parqueadero.",
    ],
    [
      "Comprueba concesión o parqueadero y período antes de comparar resultados. Un error de consulta no equivale a ausencia de transacciones.",
    ]
  );
}
// Se respetan los permisos de cada hoja, igual que en el menú y las rutas protegidas.
export function allModuleGuides(items = navigation, parents = []) {
  return items.flatMap((item) => {
    if (item.public) return [];
    if (item.collapse) return allModuleGuides(item.collapse, [...parents, item.name]);
    if (!item.route || !item.componentKey) return [];
    const document =
      specificGuides[item.key] ||
      (parents.includes("Conciliaciones") ? reconciliationGuide(item, parents) : null);
    return document
      ? [
          {
            ...document,
            ...(guideDetails[item.key] || reconciliationDetails(item.name)),
            key: item.key,
            title: item.name,
            route: item.route,
            permissionKey: item.permissionKey,
            category: parents.join(" / ") || "General",
          },
        ]
      : [];
  });
}
export function accessibleModuleGuides({ user, isLoading, hasPermission }) {
  if (!user || isLoading || typeof hasPermission !== "function") return [];
  const guides = allModuleGuides().filter(
    (item) => !item.permissionKey || hasPermission(item.permissionKey)
  );
  guides.push(conciliationFlowGuide);
  return guides;
}
